export enum OccupationTypeEnum {
  'Casa Habitual' = 4000,
  'Casa Veraneio' = 4010,
  'Apartamento Habitual' = 4070,
  'Apartamento Veraneio' = 4080,
  'Comércio' = 32236,
  'Serviços' = 32237,
};
